import { GameFontStyle } from "@lib/js-slingo-pawnshop-core/dist";
import { FeatureIntroProperties } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/properties/FeatureIntroProperties";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { Point } from "pixi.js";
export class FeatureIntroPortraitProperties extends FeatureIntroProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.background.scale.set(1, 1);
        this.background.position.set(512, 1290);
        this.titleText.position.set(512, 570);
        this.titleText.scale.set(1);
        this.titleText.size.set(700, 300);
        this.helpText = new TextFieldProperties(GameFontStyle.FEATURE_INFO_HELP_TEXT_PORTRAIT, new Point(512, 950), null, ControlConstants.CENTER, ControlConstants.CENTER, new Point(850, 600));
        this.helpText.setMultiline(true);
        this.clickToSkipText.position.set(512, 1550);
        const props = [...Object.values(this.icons), ...Object.values(this.icons[12])]
            .filter(icon => icon instanceof SpriteProperties);
        props.forEach(icon => {
            icon.scale.set(1, 1);
            icon.anchor = new Point(0.5, 0.5);
            icon.position.set(512, 525);
        });
    }
}
